export const closureReasonArray = [
  { closureReason: "Partner Termination" },
  { closureReason: "Partner Change" },
  { closureReason: "EC Move/EC Relocation" },
  { closureReason: "Permanent EC Closure" },
  { closureReason: "Mobile Event Completed" },
];
